import { render } from "./hero.vue?vue&type=template&id=744362f9&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=744362f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744362f9"]])

export default __exports__